import { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, } from "react-router-dom";
import "./Css/View.css";
import profile from "./Images/Ellipse 24 (7).png";
import API_BASE from "../config/api";

const TeacherEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const API_BASE_URL = `${API_BASE}`;

  const [teacher, setTeacher] = useState(null);
  const [showSoftwareDropdown, setShowSoftwareDropdown] = useState(false);
  const [showStandardDropdown, setShowStandardDropdown] = useState(false);
  const [showSubjectDropdown, setShowSubjectDropdown] = useState(false);
  const [dropdowns, setDropdowns] = useState({
    softwares: [],
    standards: [],
    subjects: []
  });

  const [form, setForm] = useState({
    teacherName: "",
    phoneNumber: "",
    isActive: true,
    softwareIds: [],
    standardIds: [],
    subjectIds: []
  });

  const [profilePic, setProfilePic] = useState(null);

  useEffect(() => {
    fetchTeacher();
    fetchDropdowns();
  }, [id]);

  const fetchTeacher = async () => {
    const res = await axios.get(
      `${API_BASE_URL}/api/institute/teachers/${id}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      }
    );

    setTeacher(res.data);

    setForm({
      teacherName: res.data.teacherName,
      phoneNumber: res.data.phoneNumber ?? "",
      isActive: res.data.isActive,
      softwareIds: res.data.softwares.map(s => s.id),
      standardIds: res.data.standards.map(s => s.id),
      subjectIds: res.data.subjects.map(s => s.id)
    });
  };

  const fetchDropdowns = async () => {
    const res = await axios.get(
      `${API_BASE_URL}/api/institute/teachers/dropdowns`,
      {
        params: {
          instituteId: teacher?.instituteId,
          teacherUserId: id
        },
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      }
    );

    setDropdowns(res.data);
  };

  const toggleCheckboxValue = (key, id) => {
    setForm(prev => {
      const exists = prev[key].includes(id);
      return {
        ...prev,
        [key]: exists
          ? prev[key].filter(x => x !== id)
          : [...prev[key], id]
      };
    });
  };

  const handleSave = async () => {
    const data = new FormData();

    data.append("TeacherName", form.teacherName);
    data.append("PhoneNumber", form.phoneNumber);
    data.append("IsActive", form.isActive);

    form.softwareIds.forEach(id => data.append("SoftwareIds", id));
    form.standardIds.forEach(id => data.append("StandardIds", id));
    form.subjectIds.forEach(id => data.append("SubjectIds", id));

    if (profilePic) {
      data.append("ProfilePicture", profilePic);
    }

    await axios.put(
      `${API_BASE_URL}/api/institute/teachers/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
          "Content-Type": "multipart/form-data"
        },
      }
    );

    navigate(-1);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleMultiSelect = (e, key) => {
    const values = Array.from(e.target.selectedOptions).map(o => Number(o.value));
    setForm({ ...form, [key]: values });
  };

  const handleImageChange = (e) => {
    setProfilePic(e.target.files[0]);
  };

  return (
    <div className="student-page">
      {/* Header */}
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          संस्था व्यवस्थापन  &gt;&gt; तपशील &gt;&gt; शिक्षक माहिती &gt;&gt; <span> शिक्षक संपादन</span>
        </h3>

        <div className="edit-btnn">
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>
          <button
            className="btn primaryy"
            onClick={handleSave}
          >
            सेव्ह करा
          </button>
        </div>
      </div>
      {teacher && (
        <p>संस्थेचे नाव: <strong>{teacher.instituteName}</strong></p>
      )}

      <h2>शिक्षक संपादन करा </h2>

      <div className="profile-card">
        <div className="profile-img-wrapper">
          <img
            src={
              teacher?.profilePictureUrl
                ? `${API_BASE_URL}${teacher.profilePictureUrl}`
                : profile
            }
            alt="student"
            className="profile-img"
          />

          {/* Edit Icon */}
          <label className="edit-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 18" fill="none">
              <path d="M2 16H3.425L13.2 6.225L11.775 4.8L2 14.575V16ZM0 18V13.75L13.2 0.575C13.4 0.391667 13.6208 0.25 13.8625 0.15C14.1042 0.05 14.3583 0 14.625 0C14.8917 0 15.15 0.05 15.4 0.15C15.65 0.25 15.8667 0.4 16.05 0.6L17.425 2C17.625 2.18333 17.7708 2.4 17.8625 2.65C17.9542 2.9 18 3.15 18 3.4C18 3.66667 17.9542 3.92083 17.8625 4.1625C17.7708 4.40417 17.625 4.625 17.425 4.825L4.25 18H0ZM12.475 5.525L11.775 4.8L13.2 6.225L12.475 5.525Z" fill="#ffffff" />
            </svg>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              hidden
            />
          </label>
        </div>
      </div>

      {/* Editable Grid */}
      <div className="info-gridd">
        <div className="info-boxx">
          <label>शिक्षकाचे नाव</label>
          <input
            name="teacherName"
            value={form.teacherName}
            onChange={handleChange}
          />
        </div>
        <div className="info-boxx">
          <label>ईमेल</label>
          <input type="email" value={teacher?.email} disabled />
        </div>
        <div className="info-boxx">
          <label>मोबाईल नं.</label>
          <input
            name="phoneNumber"
            value={form.phoneNumber}
            onChange={handleChange}
          />
        </div>
        <div className="info-boxx">
          <label>इयत्ता नियुक्त करा</label>

          <div
            className="dropdown-input"
            onClick={() => setShowStandardDropdown(!showStandardDropdown)}
          >
            {form.standardIds.length
              ? `${form.standardIds.length} निवडल्या`
              : "इयत्ता निवडा"}
          </div>

          {showStandardDropdown && (
            <div
              className="dropdown-options"
              onClick={(e) => e.stopPropagation()}
            >
              {dropdowns.standards.map(st => (
                <label key={st.id} className="dropdown-option">
                  <input
                    type="checkbox"
                    checked={form.standardIds.includes(st.id)}
                    onChange={() => toggleCheckboxValue("standardIds", st.id)}
                  />
                  {st.name}
                </label>
              ))}
            </div>
          )}
        </div>

        <div className="info-boxx">
          <label>परीक्षेचे नाव</label>

          <div
            className="dropdown-input"
            onClick={() => setShowSoftwareDropdown(!showSoftwareDropdown)}
          >
            {form.softwareIds.length
              ? `${form.softwareIds.length} निवडले`
              : "परीक्षा निवडा"}
          </div>

          {showSoftwareDropdown && (
            <div className="dropdown-options">
              {dropdowns.softwares.map(sw => (
                <label key={sw.id} className="dropdown-option">
                  <input
                    type="checkbox"
                    checked={form.softwareIds.includes(sw.id)}
                    onChange={() => toggleCheckboxValue("softwareIds", sw.id)}
                  />
                  {sw.name}
                </label>
              ))}
            </div>
          )}
        </div>

        <div className="info-boxx">
          <label>विषय नियुक्त करा</label>

          <div
            className="dropdown-input"
            onClick={() => setShowSubjectDropdown(!showSubjectDropdown)}
          >
            {form.subjectIds.length
              ? `${form.subjectIds.length} निवडले`
              : "विषय निवडा"}
          </div>

          {showSubjectDropdown && (
            <div
              className="dropdown-options"
              onClick={(e) => e.stopPropagation()}
            >
              {dropdowns.subjects
                .filter(s => form.standardIds.includes(s.standardId))
                .map(sub => (
                  <label key={sub.id} className="dropdown-option">
                    <input
                      type="checkbox"
                      checked={form.subjectIds.includes(sub.id)}
                      onChange={() => toggleCheckboxValue("subjectIds", sub.id)}
                    />
                    {sub.name}
                  </label>
                ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TeacherEdit;
